import { render, staticRenderFns } from "./ConsensiEditComponent.vue?vue&type=template&id=5778ff80&scoped=true"
import script from "./ConsensiEditComponent.vue?vue&type=script&lang=js"
export * from "./ConsensiEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ConsensiEditComponent.vue?vue&type=style&index=0&id=5778ff80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5778ff80",
  null
  
)

export default component.exports